import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';


export const UnauthorizedRedirect = (props: 
  { snackMessage?: string, to?: string, replace?: boolean }
) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const {
    snackMessage = ('Δεν έχετε δικαίωμα να συνεχίσετε με αυτήν την ενέργεια'),
    to = '/',
    replace = false
  } = props;
  enqueueSnackbar(t(snackMessage), { variant: 'error' });

  return <Navigate to={to} replace={replace}/>;
};

// convert the above code to a valid hook
// export const useUnauthroizedRedirect = (props: { snackMessage: string }) => {
//   const { snackMessage = 'Δεν έχετε δικαίωμα να συνεχίσετε με αυτήν την ενέργια' } = props;
//   enqueueSnackbar(snackMessage, { variant: 'error' });
//   alert(snackMessage);
//
// };

